



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 'Filtrate'
})
export default class Filtrate extends Vue {
  /**
   * @param {string} value 用于v-model 绑定数据
   * @description: 默认 radio
   */
  @Prop({
    type: [String, Number, Array]
  }) value!: string | number | any[]

  /**
   * @param {string} type 可选值 radio单选 checkbox多选
   * @description: 默认 radio
   */
  @Prop({
    type: String,
    default: 'radio'
  }) type!: 'radio' | 'checkbox'

  /**
   * @param {boolean} clear 显示隐藏 秦楚筛选项
   * @description: 默认 false
   */
  @Prop({
    type: Boolean,
    default: false
  }) clear!: boolean

  /**
   * @param {string} label label 标题
   * @description: 默认 -
   */
  @Prop({
    type: String,
    default: ''
  }) label!: string

  /**
   * @param {string} type 选项离别
   * @description: 默认 []
   */
  @Prop({
    type: Array,
    default: () => ([])
  }) list!: any[]

  radio: number | string = ''

  checkList: any[] = []

  get values (): any[] | number | string {
    if (this.value === undefined && this.type === 'checkbox') {
      return this.checkList
    }
    if (this.value === undefined && this.type === 'radio') {
      return this.radio
    }
    if (this.type === 'radio' && typeof this.value === 'object') {
      console.error('Filtrate 组件 type值 传入 radio 时, v-model 绑定的应该是一个 String | Number ')
    }
    if (this.type === 'checkbox' && !(this.value instanceof Array)) {
      console.error('Filtrate 组件 type值 传入 checkbox 时, v-model 绑定的应该是一个 Array ')
    }
    console.log(this.list, this.value, 778899)
    return this.value
  }

  set values (newData) {
    if (this.value === undefined && (newData instanceof Array)) {
      this.checkList = newData
    } else if (this.value === undefined && !(newData instanceof Array)) {
      this.radio = newData
    } else {
      this.handleValue(newData)
    }
  }

  @Emit('input')
  handleValue (newData) {
    return newData
  }

  @Emit('clear')
  clickClear () {
    this.values = []
    // for (let i = 0; i < this.list.length; i++) {
    //   const item = this.list[i]
    //   if (typeof this.values === 'object' && this.values.includes(item.tagId)) {
    //     this.values.splice(this.values.indexOf(item.tagId), 1)
    //   }
    // }
    return ''
  }

  @Emit('change')
  handleChange (item) {
    return item
  }
}
